"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Option {
  constructor(props) {
    this.key = props.key;
    this.setValue(props.value);
  }
  setValue(value) {
    this.value = value;
  }
  getKey() {
    return this.key;
  }
  getValue() {
    return this.value;
  }
}
exports.Option = Option;
//# sourceMappingURL=Option.js.map
